import { useState } from 'react';

import useError from '@/hooks/useError';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';

const useGetELabelShipmentBinary = () => {
  const addError = useError();
  const [{ loading }, makeRequest] = useImperativeRequestWrapper('shipment');
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  const fetch = async (id: string) => {
    const { error, data } = await makeRequest({
      path: `/shipments/${id}/elabel/binary?format=BMP`,
      method: 'get',
      responseType: 'blob',
    });
    if (error) {
      addError(error);

      return { success: false };
    }

    // Revoke previous blob URL to avoid memory leaks
    if (blobUrl) {
      URL.revokeObjectURL(blobUrl);
    }

    // Create a blob URL directly from the blob
    const url = URL.createObjectURL(data);
    setBlobUrl(url);

    return { success: true };
  };

  return {
    fetch,
    blobUrl,
    loading,
  };
};
export default useGetELabelShipmentBinary;
